// Mirrors Wheels.ERP.Shared.Catalog promotion DTOs.

export const PROMOTION_TYPE = {
  PERCENTAGE_OFF_ORDER: 1,
  BOGO_SAME_ITEM: 2,
  AMOUNT_OFF_ORDER: 3,
} as const;

export type PromotionType =
  (typeof PROMOTION_TYPE)[keyof typeof PROMOTION_TYPE];

export interface PromotionDto {
  promotionId: string;
  code: string;
  nameAr: string;
  nameEn: string | null;
  type: number;
  discountPercent: number;
  activeFrom: string | null;
  activeTo: string | null;
  isActive: boolean;
  targetItemId: string | null;
  bogoBuyQty: number;
  bogoFreeQty: number;
  discountAmount: number;
  minOrderSubtotal: number;
}

export interface CreatePromotionRequest {
  code: string;
  nameAr: string;
  nameEn?: string | null;
  type?: number;
  discountPercent: number;
  activeFrom?: string | null;
  activeTo?: string | null;
  targetItemId?: string | null;
  bogoBuyQty?: number;
  bogoFreeQty?: number;
  discountAmount?: number;
  minOrderSubtotal?: number;
}

export interface UpdatePromotionRequest {
  code: string;
  nameAr: string;
  nameEn?: string | null;
  type?: number;
  discountPercent: number;
  activeFrom?: string | null;
  activeTo?: string | null;
  isActive: boolean;
  targetItemId?: string | null;
  bogoBuyQty?: number;
  bogoFreeQty?: number;
  discountAmount?: number;
  minOrderSubtotal?: number;
}
